/* Keeps the green Quick view bar sitting on the product photo.

   The bar is anchored to the top edge of the card's text block. On products
   with colour swatches the Swatch King app injects a <variant-swatch-king>
   row between the photo and that text block, which pushes the anchor down by
   the height of that row -- so the bar lands below the photo instead of on it.

   This measures that row per card and exposes it as --m-swatch-h, which
   assets/monroe-cards-v2.css adds to the offset. Cards without swatches
   measure 0 and are unaffected.

   Loaded from the 'brand-styles' block in sections/header-group.json. */

(function () {
  'use strict';

  function measure(card) {
    var sw = card.querySelector('variant-swatch-king');
    var h = sw ? Math.round(sw.getBoundingClientRect().height) : 0;
    card.style.setProperty('--m-swatch-h', h + 'px');
  }

  function measureAll() {
    var cards = document.querySelectorAll('.product-card-wrapper .card--standard');
    for (var i = 0; i < cards.length; i++) measure(cards[i]);
  }

  /* The app fills the swatch row asynchronously, so watch it resize. */
  var ro = null;
  if ('ResizeObserver' in window) {
    ro = new ResizeObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var card = entries[i].target.closest('.card--standard');
        if (card) measure(card);
      }
    });
  }

  function observeSwatches() {
    if (!ro) return;
    var rows = document.querySelectorAll('.product-card-wrapper variant-swatch-king');
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].dataset.mSwatchWatched) continue;
      rows[i].dataset.mSwatchWatched = '1';
      ro.observe(rows[i]);
    }
  }

  var pending = null;
  function refresh() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      measureAll();
      observeSwatches();
    }, 50);
  }

  function boot() {
    measureAll();
    observeSwatches();

    /* Only childList, never attributes: measure() writes an inline style and
       an attribute observer would loop. */
    new MutationObserver(refresh).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('resize', refresh, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
